module.exports = __webpack_public_path__ + "img/telephone.9159fe85.png";